import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import CryptoJS from "crypto-js";
import { PATHS } from "../../Constants";
import UpgradeHandlerAction from "./UpgradeHandlerAction";
import { OperationStatus } from "../../Communication/Constants";
import { Strings } from "../../Resources/Strings/i18n";
import Spinner from "../Spinner/Spinner";
import { Alert } from "react-bootstrap";
import "./UpgradeHandler.scss";

class UpgradeHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinner: false,
      userId:"",
      userData: "",
      accessToken: "",
      errorMessage: "",
      errorCase: false,
    }
    this.UpgradeHandlerAction = new UpgradeHandlerAction();
  }


  componentDidMount = () => {
    // this.props.cleanUserAccessTokenInfo();
    const secretKey = this.props.match.params.secret_key;
    const userId = this.props.match.params.id;
    const deviceType = this.props.match.params.device_type;
    // console.log('SecretKey', secretKey)
    // console.log('userId', userId)
    // console.log('deviceType', deviceType)
    const decryptedStringData = this.decryptTextCrypto(secretKey)
    // console.log('decryptedStringData', decryptedStringData);
    let encrptedSecretKey;
    if (decryptedStringData !== process.env.REACT_APP_SUBSCRIPTION_KEY) {
      // console.log('invalid web token')
      this.setState({
        errorCase: true,
        errorMessage: Strings("ERROR_INVALID_WEB_TOKEN"),
        showModal: false,
      });
    }
    else if (!userId) {
      this.setState({
        errorCase: true,
        errorMessage: Strings("ERROR_INVALID_USER_ID"),
        showModal: false,
      });
    }

    else if (!deviceType) {
      this.setState({
        errorCase: true,
        errorMessage: Strings("ERROR_INVALID_DEVICE_TYPE"),
        showModal: false,
      });
    }

    else {
      this.setState({ spinner: true });
      encrptedSecretKey = this.encryptTextCrypto(secretKey);
      this.UpgradeHandlerAction.getAccessToken(encrptedSecretKey, userId, deviceType, (actionCallback) => {
        if (actionCallback.status === OperationStatus.SUCCESS) {
            this.setState({
              spinner: false,
              userId: actionCallback.data.data.feResponse.user_id,
              accessToken : actionCallback.data.data.feResponse.access_token,
              userData: actionCallback.data.data.feResponse.user_data,
              showModal: false,
            });
            this.props.history.push(PATHS.PLANS);
        }
        else {
            this.setState({
              spinner: false,
              errorCase: true,
              errorMessage: actionCallback.error.errorMessage,
              showModal: false,
            });
        }
      });
    }   
  };

  showModal = () => {
    this.setState({ show: true });
  };

  renderAlert = () => {
    return (
        <Alert variant="danger" className="alertMessage">
            {this.state.errorMessage}
        </Alert>
    );
  };

  encryptTextCrypto = (secretKey) => {
    // Encrypt
    const newSecretKey = `${secretKey}##${process.env.REACT_APP_NEW_SUBSCRIPTION_FLOW_SECRET_KEY}`
    const encryptedSecretKey = CryptoJS.AES.encrypt(newSecretKey, process.env.REACT_APP_SUBSCRIPTION_KEY).toString();
    return encryptedSecretKey;
  };

  decryptTextCrypto = (encryptedSecretKey) => {
    // Decrypt
    const actualEncryptedString =  encryptedSecretKey.split('atman123').join('/').split('allwell123').join('+');
    // console.log('actualEncryptedString: -->', actualEncryptedString);
    const decryptedStringData = CryptoJS.AES.decrypt(actualEncryptedString, process.env.REACT_APP_SUBSCRIPTION_KEY).toString(CryptoJS.enc.Utf8)
    // console.log('decryptedStringData', decryptedStringData);
    return decryptedStringData;
  }

  state = {};
  render() {
    return (
      <div className="upgradeHandler">
        {this.state.errorCase ? this.renderAlert() : null}
        <Spinner showModal={this.state.spinner} />{" "}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
   userAccessTokenInfo: state.UpgradeHandler.userAccessTokenInfo,
  };
}


function matchDispatchToProps(dispatch) {
  return {
    cleanUserAccessTokenInfo: () => dispatch({ type: 'CLEAN_USER_ACCESS_TOKEN_DATA' }),
  }
}

UpgradeHandler.defaultProps = {
  userAccessTokenInfo: { Error: "No data recieved" },
};

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(UpgradeHandler)
);

// export default UpgradeHandler;